import AdminPage from "../UI/AdminPage";
import AdminProducts from "../UI/Workspace/AdminPage/AdminProducts";
import AdminCategories from "../UI/Workspace/AdminPage/AdminCategories";
import AdminProjects from "../UI/Workspace/AdminPage/AdminProjects";
import AdminCustomers from "../UI/Workspace/AdminPage/AdminCustomers";
import AdminUsers from "../UI/Workspace/AdminPage/AdminUsers";
import AdminOrganizations from "../UI/Workspace/AdminPage/AdminOrganizations";
import AdminIncoming from "../UI/Workspace/AdminPage/AdminIncoming";
import AdminConfig from "../UI/Workspace/AdminPage/AdminConfig";

export default {
    name: "administration",
    path: '/admin',
    component: AdminPage,
    meta: {requiresAuth: true, accessRightsAP: true, applicationVersion: 'adminPanel'},
    children: [
        {
            name: "adminProducts",
            path: 'products',
            components: {
                workspace: AdminProducts,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "AdminCategories",
            path: 'collections',
            components: {
                workspace: AdminCategories,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "adminProjects",
            path: 'projects',
            components: {
                workspace: AdminProjects,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "adminIncoming",
            path: 'incoming',
            components: {
                workspace: AdminIncoming,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "adminCustomers",
            path: 'customers',
            components: {
                workspace: AdminCustomers,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "adminUsers",
            path: 'users',
            components: {
                workspace: AdminUsers,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "adminOrganizations",
            path: 'organizations',
            components: {
                workspace: AdminOrganizations,
            },
            meta: {requiresAuth: true}
        },
        {
            name: "adminConfig",
            path: 'configuration',
            components: {
                workspace: AdminConfig,
            },
            meta: {requiresAuth: true}
        },
    ]
};
